import { environment } from '../environments/environment';

export const DB_CONFIG = {
    answer_endpoint: 'answers',
    apps_endpoint: 'apps',
    app_special_stats_endpoint: 'app_special_stats',
    apps_skipped_endpoint: 'apps_skipped',
    assessment_endpoint: 'assessment',
    brain_game_leaderboard_endpoint: 'brain_game_leaderboard',
    bg_responses_endpoint: 'bg_responses',
    brain_charge_scores_endpoint: 'brain_charge_scores',
    clubhouse_tracking_endpoint: 'clubhouse_tracking',
    data_tracker_endpoint: 'data_tracker',
    did_you_know_endpoint: 'did_you_know',
    // The production Trigger Email extension watches `mail`. Development writes
    // to a sink collection so tests cannot email real recipients.
    email_endpoint: environment.production ? 'mail' : 'mail_dev',
    email_templates_endpoint: 'email_templates',
    exercise_endpoint: 'exercise',
    featured_activities: 'featured_activities',
    game_endpoint: 'game',
    games_endpoint: 'games',
    games_skipped_endpoint: 'games_skipped',
    global_level_endpoint: 'global_level',
    happy_place_endpoint: 'happy_place',
    happy_place_tracking_endpoint: 'happy_place_tracking',
    highlights_endpoint: 'highlights',
    level_endpoint: 'levels',
    llm_feedback_endpoint: 'llm_feedback',
    meeting_endpoint: 'meeting',
    mood_sleep_endpoint: 'mood_sleep',
    overall_session_endpoint: 'overall_sessions',
    outside_training_endpoint: 'outside_training',
    presentation_endpoint: 'presentations',
    question_endpoint: 'questions',
    quiz_endpoint: 'quiz',
    sliding_endpoint: 'sliding',
    stat_tracker_endpoint: 'stat_tracker',
    sub_activities_endpoint: 'sub_activities',
    subscriber_endpoint: 'subscriber',
    summary_answer_endpoint: 'summary_answers',
    user_endpoint: 'users',
    yahootie_config_endpoint: 'yahootie_config',
    yahootie_questions_endpoint: 'yahootie_questions',
    yahootie_result_endpoint: 'yahootie_result',
    yahootie_result_report_endpoint: 'yahootie_result_report',
    yahootie_score_endpoint: 'yahootie_score',
    
    // old tables
    team_endpoint: 'team',
    team_player_endpoint: 'team_player',
    event_endpoint: 'event',
    profile_endpoint: 'profile',
    result_endpoint: 'result',
};

const expectedProjectId = environment.production
    ? 'brain-evolved'
    : 'brain-evolved-dev';

if (environment.firebase.projectId !== expectedProjectId) {
    throw new Error(
        `Invalid ${environment.name} Firebase configuration: expected ${expectedProjectId}, ` +
        `received ${environment.firebase.projectId}.`
    );
}

const appIdProjectNumber = environment.firebase.appId.split(':')[1];
if (appIdProjectNumber !== environment.firebase.messagingSenderId) {
    throw new Error(
        `Firebase appId and messagingSenderId do not belong to the same project in ` +
        `${environment.name}.`
    );
}

/**
 * Firebase web configuration is public application metadata, not a secret.
 * Authorization is enforced with Firebase Auth, Security Rules, IAM, and App Check.
 */
export const FIREBASE_CONFIG = Object.freeze({ ...environment.firebase });

export const APP_ENVIRONMENT = Object.freeze({
    name: environment.name,
    production: environment.production,
    firebaseProjectId: environment.firebase.projectId
});

export const CLOUD_FUNCTIONS_BASE_URL =
    `https://${environment.cloudFunctions.region}-${environment.firebase.projectId}.cloudfunctions.net`;